import React, { useState } from "react";
import Moment from "moment";
import "moment/locale/es";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@mui/material";
import ScrollBar from "../../../components/Scrollbar";
import { useMutation, useQuery } from "@apollo/client";
import { ELIMINAR_EGRESO, OBTENER_EGRESOS_DIA } from "../../../graphql/egresos";
import MovimientosHeader from "../../../components/TableHeader/MovimientosHeader";
import Iconify from "../../../components/Iconify";
const TABLE_HEAD = [
  { id: "categoria", label: "Tipo de Egreso", alignRight: false },
  { id: "Subcategoria", label: "Concepto", alignRight: false },
  { id: "fechaEgreso", label: "Fecha de Gasto", alignRight: false },
  { id: "fechaSistema", label: "Fecha de Registro", alignRight: false },
  { id: "descripcion", label: "Concepto Anterior", alignRight: false },
  { id: "monto", label: "Monto", alignRight: false },
];
const EgresosTable = ({
  setOpenDialog,
  setBodyDialog,
  setErrorGraph,
  setOpenSnackBar,
}) => {
  const { data, loading, error, refetch } = useQuery(OBTENER_EGRESOS_DIA);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [eliminarEgreso] = useMutation(ELIMINAR_EGRESO);
  if (loading) {
    return <h1>Cargando....</h1>;
  }
  const { obtenerEgresos } = data;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDeactivateRecord = async (id) => {
    try {
      const result = await eliminarEgreso({
        variables: {
          id: parseInt(id),
        },
      });
      setOpenSnackBar(true);
      setErrorGraph({
        mensaje: result.data.eliminarEgreso,
        severity: "success",
      });
      refetch();
    } catch (error) {
      setOpenSnackBar(true);
      setErrorGraph({ mensaje: error.message, severity: "error" });
    }
  };
  return (
    <>
      <ScrollBar>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table>
            <MovimientosHeader headLabel={TABLE_HEAD} />
            <TableBody>
              {obtenerEgresos
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  const {
                    id,
                    descripcion,
                    fechaEgreso,
                    createdAt,
                    CatEgresosModel,
                    MovimientosModel,
                    detalleCuentasEgresosModel,
                  } = row;
                  return (
                    <TableRow hover key={createdAt} tabIndex={-1}>
                      <TableCell>{CatEgresosModel.clave}</TableCell>
                      <TableCell>
                        {detalleCuentasEgresosModel?.descripcion}
                      </TableCell>

                      <TableCell>
                        {Moment(fechaEgreso).format("DD-MMMM-YYYY")}
                      </TableCell>
                      <TableCell>
                        {Moment(createdAt).format("DD-MMMM-YYYY")}
                      </TableCell>
                      <TableCell>{descripcion}</TableCell>
                      <TableCell>$ {MovimientosModel.monto}</TableCell>
                      <TableCell>
                        <Button
                          value={id}
                          onClick={(e) => {
                            handleDeactivateRecord(id);
                          }}
                          color="error"
                          startIcon={<Iconify icon="eva:close-outline" />}
                        >
                          Eliminar Operación
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </ScrollBar>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        page={page}
        count={obtenerEgresos.length}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default EgresosTable;
